import React from 'react';
import PropTypes from 'prop-types';
import { Badge } from "components/common";

// Keys match the backend co_status enum (canonical snake_case values).
const ChangeOrderStatus = ({status}) => {
  let variant = "primary"

    switch(status) {
      case "submitted":
        variant = "default"
        break
      case "sent":
        variant = "warning"
        break
      case "requested_revise":
        variant = "warning"
        break
      case "accepted_revise":
        variant = "success"
        break
      case "rejected":
        variant = "danger"
        break
      case "rejected_and_closed":
        variant = "cancelled"
        break
      case "accepted":
        variant = "success";
        break;
      default:
        variant = "primary"
        break
    }

  return (
    <Badge variant={variant} size="sm" className="tw-capitalize">{status?.replace(/_/g, ' ')}</Badge>
  )
};

ChangeOrderStatus.propTypes = {
  status: PropTypes.string.isRequired
}

export default ChangeOrderStatus;
